import React from "react";
import { styled, css } from "styled-components";
const StyledFormElementWrapper = styled.div `
  width: 100%;
  padding-bottom: 1rem;

  ${({ noPadding }) => noPadding &&
    css `
      padding: 0;
    `};
`;
export const FormElementWrapper = ({ dataCy, children, noPadding = false }) => (React.createElement(StyledFormElementWrapper, { "data-cy": dataCy, noPadding: noPadding }, children));
export default FormElementWrapper;
//# sourceMappingURL=index.js.map